var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"dataChart":_vm.chartData,"countGraph2":_vm.renderChart,"options":_vm.graphOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }